import * as React from 'react';

export const RequiredAsterisk = () => <span className="text-danger">*</span>;

const RequiredLabel = () => (
  <span className="text-danger">*Required field</span>
);

export default RequiredLabel;
